import React, {ReactElement} from 'react';
import {Center} from 'components/Center';
import {Display} from 'components/Display';
import {MainMenu} from 'components/MainMenu';
import {Header} from 'components/Header';
import {Dialogue} from 'components/Dialogue';
import {Undo} from 'components/Undo';
import {Wrapper} from './style';

export const MainScreen = (): ReactElement => (
  <Wrapper>
    <Center>
      <Header>
        <MainMenu />
      </Header>

      <Dialogue />
      <Display />
      <Undo />
    </Center>
  </Wrapper>
);
